<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 6">
    <path
      d="M.3 5.697c.193.193.452.3.73.303a.998.998 0 0 0 .756-.303L5 2.494l3.213 3.203c.193.193.453.3.73.303h.01c.279 0 .542-.107.743-.3.404-.388.407-1.041.003-1.46L5.737.304a1.026 1.026 0 0 0-.72-.301C4.98-.001 4.982 0 4.965 0a.991.991 0 0 0-.703.303L.3 4.253c-.4.398-.4 1.046 0 1.444"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
